
export const getRelativeTimeString = (dateStr: string, id?: string): string => {
    if (!dateStr) return '';

    // 1. Try to extract timestamp from id (format: post-123456789)
    let timestamp = 0;
    if (id && id.startsWith('post-')) {
        const tsPart = id.split('-')[1];
        if (tsPart && !isNaN(Number(tsPart))) {
            timestamp = Number(tsPart);
        }
    }

    // 2. Fallback to parsing dateStr (format: YYYY.MM.DD)
    if (timestamp === 0) {
        const parts = dateStr.split('.');
        if (parts.length === 3) {
            const year = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const day = parseInt(parts[2]);
            timestamp = new Date(year, month, day).getTime();
        }
    }

    if (timestamp === 0) return dateStr;

    const now = Date.now();
    const diff = now - timestamp;

    // If it's more than 24 hours ago, show the original date string
    if (diff > 24 * 60 * 60 * 1000 || diff < 0) {
        return dateStr;
    }

    const minutes = Math.floor(diff / (60 * 1000));
    const hours = Math.floor(diff / (60 * 60 * 1000));

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes} min ago`;
    return `${hours} hours ago`;
};
